import {
  asyncTeacherRoutes,
  asyncAgentRoutes,
  asyncTeacherEdit
} from './config/router';
import { router } from './config';
import { getToken, getUserType, getTeacherInfo } from '@/utils/teacherAuth'; // get token from cookie
import { store, mutations } from '@/store';
import { getTeacherLinks } from '@/utils/domainUtils';
const whiteList = [
  '/login',
  '/hiring',
  '/apply-table',
  '/more-link',
  '/networkTest'
];

router.beforeEach(async (to, from, next) => {
  //确定用户是否已登录
  const hasToken = getToken();
  const hasUserType = getUserType();
  if (hasToken && hasUserType) {
    if (store.hasRoute) {
      next();
    } else {
      let accessRoutes = [];
      if (hasUserType === '1') {
        //用户为老师
        const userInfo = JSON.parse(getTeacherInfo());
        if (userInfo.accountStatus === 2) {
          //审核通过的老师
          accessRoutes = asyncTeacherRoutes;
        } else {
          accessRoutes = asyncTeacherEdit;
        }
      } else if (hasUserType === '8') {
        //用户为代理端
        accessRoutes = asyncAgentRoutes;
      }
      mutations.setHasRoute(true);
      router.addRoutes(accessRoutes);
      next({ ...to, replace: true });
    }
  } else {
    if (whiteList.indexOf(to.path) !== -1) {
      // 在免费登录白名单中，直接进入
      next();
    } else {
      //如果没有登录信息则跳转到学生端登录页面
      const teacherLinks = getTeacherLinks();
      window.location.href = teacherLinks.TEACHER_LOGIN_LINK;
    }
  }
});



// WEBPACK FOOTER //
// ./src/permission.js